import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Text from "components/common/Text";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import TextField from "components/common/TextField";
import DatePicker from "components/common/DatePicker";
import IconButton from "components/common/IconButton";
import JarvisButton from "components/JarvisButton";
import CheckIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SectionTitle from "components/SectionTitle";
import { Checkbox, CircularProgress } from "@mui/material";
import OtpInput from "react-otp-input";
import Button from "components/common/Button";
import { makeStyles } from "@mui/styles";
import { masterApis } from "stores/master/masterApis";
import { useDispatch } from "react-redux";
import { commonActions } from "stores/common/commonActions";

const useStyles = makeStyles(() => ({
  otpContainer: {
    height: "56px",
    width: "100%",
  },
  otpInput: {
    height: "56px",
    width: "57px",
    border: "1px solid #E0E7FF",
    flex: "1",
  },
  otpResend: {
    color: "#72aaff",
    background: "transparent !important",
    padding: "0",
    boxShadow: "none !important",
    fontSize: "12px",
    display: "inline",
    textTransform: "none",
    cursor: "pointer",
    minWidth: "auto",
    marginRight: "8px",
  },
}));

const CKYCauto = (props) => {
  const classes = useStyles();
  const {
    formData,
    formError,
    isVerified,
    isLoading,
    hasFirstAttempError,

    handleChange,
    handleVerification,
    toggleKYCtype,
    isReKyc,
    reKycButton,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const [isSize, setSize] = useState(window.innerHeight > 800);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [isOtpSend, setIsOtpSend] = useState(false);
  const [resendTime, setResendTime] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [isAadharDone, setisAadharDone] = useState(true);
  const [aadharNumber, setAadharNumber] = useState("");
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [optVerifyButton, setVerifyButton] = useState(false);

  const [formErrorAadhar, setFormErrorAadhar] = useState({
    aadharNumber: "",
  });
  const [isVerifiedAadhar, setIsVerifiedAadhar] = useState(false);

  const updateSize = () => {
    setSize(window.innerHeight > 800);
  };

  useEffect(() => {
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  });

  const handleCheckBoxChange = (value) => {
    setCheckBoxStatus(value);
  };

  const handleSendOtp = async (isResendOtp) => {
    setIsLoadingButton(true);
    setIsButtonVisible(false);
    const dataObject = {
      aadhaarNumber: aadharNumber,
    };
    try {
      const getAadharOtp = masterApis.getOtpAadharKYCApi;
      Promise.resolve(getAadharOtp(dataObject)).then((res) => {
        if (res.code == "SOS174") {
          if (isResendOtp) {
          } else {
            setIsOtpSend(true);
          }
        } else {
          setFormErrorAadhar({ ...formErrorAadhar, aadharNumber: res.message });
          setIsLoadingButton(false);
          setIsButtonVisible(true);
        }
      });
    } catch (error) {
      console.log(error);
      setIsLoadingButton(false);
      setIsButtonVisible(true);
    }
  };

  const handleRequestOtp = () => {
    startTimer();
    handleSendOtp(true);
  };

  const startTimer = (initialTime = 30, intervalDuration = 1000) => {
    if (resendTime > 0) {
      return;
    }
    setResendTime(initialTime);
    const id = setInterval(() => {
      setResendTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(id);
          return 0;
        }
        return prevTime - 1;
      });
    }, intervalDuration);
    setIntervalId(id);
  };

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  const handleAadharChange = (e) => {
    const value = e.target.value;
    setAadharNumber(value);

    const errorMessage = validateAadharNumber(value);
    setFormErrorAadhar({ ...formErrorAadhar, aadharNumber: errorMessage });
  };

  const validateAadharNumber = (value) => {
    const regex = /^\d{12}$/;
    if (!value) {
      return "Aadhaar number is required";
    } else if (!regex.test(value)) {
      return "Aadhaar number must be 12 digits";
    } else {
      return "";
    }
  };

  const verfiyOtpHandler = async () => {
    setVerifyButton(true);
    const objectData = {
      otp: formData.otp,
      aadhaarNumber: aadharNumber,
      consent: "Y",
    };
    try {
      const otpVerifyAPiCall = masterApis.verfyOtpAadharKYCApi;
      Promise.resolve(otpVerifyAPiCall(objectData)).then((res) => {
        if (res.code == "SRC001") {
          dispatch(commonActions.setToast({ message: res.message }));
          setIsVerifiedAadhar(true);
          setisAadharDone(false);
          handleChange({
            name: "otp",
            value: "",
          });
          setVerifyButton(false);
        } else {
          dispatch(commonActions.setToast({ message: res.message }));
          setVerifyButton(false);
        }
      });
    } catch (error) {
      console.log(error);
      setVerifyButton(false);
    }
  };

  return (
    <Stack sx={{ pt: { xs: 2, md: 0 }, alignItems: "flex-start" }}>
      {/* Back button */}
      <SectionTitle
        sx={{ display: { xs: "flex", md: "none" } }}
        heading={isReKyc ? "Re-CKYC Update" : "Complete CKYC"}
        startIcon={
          <IconButton
            onClick={() => history.push({ pathname: "/customer/product-info" })}
          >
            <ArrowBackIcon sx={{ fontSize: 20, color: "#222B3E" }} />
          </IconButton>
        }
      />
      {isReKyc && (
        <Text
          mb={3}
          sx={{
            display: { xs: "none", md: "flex" },
            fontSize: { xs: "body2.fontSize", md: "body1.fontSize" },
            fontWeight: 400,
          }}
        >
          Re-CKYC Update
        </Text>
      )}

      <Text
        mb={2}
        sx={{
          fontSize: { xs: "body2.fontSize", md: "body1.fontSize" },
          fontWeight: 400,
          width: { xs: "360px", md: 850 },
          textAlign: "left",
        }}
      >
        Please keep your Aadhaar and PAN number handy and make sure that the
        mobile number linked to your Aadhaar number is within the network range,
        as you will get OTP to verify CKYC
      </Text>

      {hasFirstAttempError ? (
        <Stack direction="row" alignItems="center" mb={2}>
          <ErrorIcon sx={{ fontSize: 24, color: "#BC2B2B" }} />
          <Text
            variant="body2"
            sx={{ color: "#BC2B2B", maxWidth: "400px", ml: 0.5 }}
          >
            Verification Failed! We can't find your CKYC records.
          </Text>
        </Stack>
      ) : null}

      {/* aadhaar and sent otp */}
      <Stack
        sx={{
          display: "block",
          width: "100%",
          mb: 3,
        }}
      >
        <TextField
          type="text"
          label="Aadhaar No."
          value={aadharNumber}
          onChange={handleAadharChange}
          helperText={
            isVerifiedAadhar
              ? "Successfully Completed."
              : formErrorAadhar.aadharNumber || " "
          }
          error={Boolean(formErrorAadhar.aadharNumber)}
          disabled={isVerifiedAadhar}
          sx={{ maxWidth: 400 }}
          inputProps={{ maxLength: 12 }}
        />
        {isOtpSend ? null : aadharNumber.length == 12 ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ maxWidth: 400 }}
          >
            <Text variant="caption1"></Text>
            <Text
              variant="caption1"
              sx={{
                whiteSpace: "nowrap",
                alignSelf: "flex-end",
              }}
            >
              {isLoadingButton && <CircularProgress size={20} />}
              {isButtonVisible && (
                <Button
                  component="span"
                  className={classes.otpResend}
                  onClick={() => handleSendOtp(false)}
                  disabled={resendTime > 0 ? true : false}
                  loading={isLoading}
                >
                  Send OTP
                </Button>
              )}
            </Text>
          </Stack>
        ) : null}
      </Stack>

      {/* resend otp */}
      {!isVerifiedAadhar && isOtpSend && (
        <Stack
          sx={{
            display: "block",
            width: { xs: "100%", md: "26.3%" },
            mb: 3,
          }}
        >
          <OtpInput
            className={classes.otpContainer}
            inputStyle={classes.otpInput}
            value={formData.otp}
            numInputs={6}
            onChange={(otp) =>
              handleChange({
                name: "otp",
                value: otp,
              })
            }
            isInputNum={true}
            separator={<span>&nbsp;</span>}
          />
          <Stack direction="row" justifyContent="space-between">
            <Text variant="caption1"></Text>
            <Text
              variant="caption1"
              sx={{
                whiteSpace: "nowrap",
                alignSelf: "flex-end",
              }}
            >
              <Button
                component="span"
                className={classes.otpResend}
                onClick={handleRequestOtp}
                disabled={resendTime > 0 ? true : false}
                loading={isLoading}
              >
                Resend
              </Button>

              {resendTime > 0 ? `in 00:${resendTime}` : null}
            </Text>
          </Stack>
          <JarvisButton
            disableEndIcon={true}
            sx={{ width: { xs: "100%", md: "auto" } }}
            onClick={verfiyOtpHandler}
            loading={optVerifyButton}
          >
            Confirm OTP
          </JarvisButton>
        </Stack>
      )}

      {/* PAN */}
      <TextField
        type="text"
        label="PAN No."
        value={formData.panNumber}
        onChange={(e) =>
          handleChange({
            name: "panNumber",
            value: e.target.value.toUpperCase(),
          })
        }
        helperText={formError.panNumber}
        error={formError.panNumber}
        disabled={isVerified || isAadharDone}
        sx={{ maxWidth: 400, mb: 2 }}
        inputProps={{ maxLength: 12 }}
      />

      {/* Data*/}
      <DatePicker
        label="Date of Birth"
        value={formData.dateOfBirth}
        onChange={(value) => handleChange({ name: "dateOfBirth", value })}
        helperText={formError.dateOfBirth}
        error={formError.dateOfBirth}
        disabled={isVerified || isAadharDone}
        textFieldProps={{
          sx: { maxWidth: 400, mb: 2 },
        }}
      />

      {/* Msg: success */}
      {isVerified ? (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ display: "flex", mb: { xs: 0, md: 4 } }}
        >
          <CheckIcon sx={{ fontSize: 24, color: "#18A70E" }} />
          <Text variant="body2" sx={{ color: "#18A70E" }}>
            Account verification successful
          </Text>
        </Stack>
      ) : null}

      {/* Msg: fail */}
      {/* {hasFirstAttempError ? (
        <Stack
          direction="row"
          alignItems="flex-start"
          spacing={1}
          sx={{
            display: isVerified || true ? "flex" : "none",
            mb: { xs: 4, md: 4 },
          }}
        >
          <Text
            component="span"
            sx={{
              textDecoration: "underline",
              cursor: "pointer",
              color: "blue",
              "&:hover": {
                color: "#e60b0b",
              },
            }}
            onClick={() => toggleKYCtype(true)}
          >
            {` `}Click here for manually CKYC
          </Text>
        </Stack>
      ) : null} */}

      {/* Submit: verification */}

      {isReKyc ? (
        <Stack
          justifyContent={{ xs: "center", md: "flex-start" }}
          mt={4}
          sx={{
            width: { xs: "100%", md: "auto" },
            position: { xs: "fixed", md: "relative" },
            bottom: { xs: 10 },
          }}
        >
          <JarvisButton
            disableEndIcon={true}
            sx={{ width: { xs: "91%", md: "auto" } }}
            disabled={isAadharDone}
            onClick={() => handleVerification()}
            loading={reKycButton}
          >
            Submit for re-verification
          </JarvisButton>
        </Stack>
      ) : !isVerified ? (
        <Stack
          direction="row"
          justifyContent={{ xs: "center", md: "flex-start" }}
          mb={{ xs: 7, md: 3 }}
          mt={6}
          alignItems="center"
          sx={{ width: { xs: "100%", md: "auto" }, background: "#fff" }}
        >
          {isSize ? (
            <Stack
              sx={{
                position: { xs: "fixed", md: "unset" },
                bottom: { xs: "10px", md: "unset" },
                width: { xs: "90vw", md: "unset" },
              }}
            >
              {/* CKYC Checkbox */}
              <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                marginBottom="1rem"
              >
                <Checkbox
                  sx={{ px: 1, py: 0, pl: 0 }}
                  onChange={(e) => handleCheckBoxChange(e.target.checked)}
                  value={checkBoxStatus}
                />
                <Box>
                  <Text
                    variant="caption1"
                    sx={{
                      display: {
                        md: "block",
                      },
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: "3",
                      overflow: "hidden",
                    }}
                  >
                    I hereby provide consent to Ventugrow Consultants Pvt Ltd to
                    retrieve my KYC from <b>CKYCRR </b>
                    and download it as per{" "}
                    <b>SEBI (IA) Regulations, (2013), </b>
                    including all subsequent amendments.
                  </Text>
                </Box>
              </Stack>
              <JarvisButton
                sx={{ width: { xs: "100%", md: "auto" } }}
                loading={isLoading}
                disabled={!checkBoxStatus}
                onClick={handleVerification}
              >
                Submit for verification
              </JarvisButton>
            </Stack>
          ) : (
            <Stack
              sx={{
                position: { xs: "static", md: "unset" },
                bottom: { xs: "10px", md: "unset" },
                width: { xs: "90vw", md: "unset" },
              }}
            >
              {/* CKYC Checkbox */}
              <Stack
                sx={{
                  alignItems: { xs: "flex-start", md: "center" },
                  marginBottom: { xs: "1rem", md: "0.313rem" },
                }}
                direction="row"
                justifyContent="flex-start"
              >
                <Checkbox
                  sx={{ px: 1, py: 0, pl: 0 }}
                  onChange={(e) => handleCheckBoxChange(e.target.checked)}
                  value={checkBoxStatus}
                />
                <Box>
                  <Text
                    variant="caption1"
                    sx={{
                      display: {
                        md: "block",
                      },
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: "3",
                      overflow: "hidden",
                    }}
                  >
                    I hereby provide consent to Ventugrow Consultants Pvt Ltd to
                    retrieve my KYC from <b>CKYCRR </b>
                    and download it as per{" "}
                    <b>SEBI (IA) Regulations, (2013), </b>
                    including all subsequent amendments.
                  </Text>
                </Box>
              </Stack>
              <JarvisButton
                sx={{ width: { xs: "100%", md: "30%" } }}
                loading={isLoading}
                disabled={!checkBoxStatus}
                onClick={handleVerification}
              >
                Submit for verification
              </JarvisButton>
            </Stack>
          )}
        </Stack>
      ) : null}
    </Stack>
  );
};

export default CKYCauto;
